import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { StatusTagCell } from "@/molecules/StatusTagCell"

import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTable = (t: TFunction) => {
  const tKey = (key: string) =>
    t(`inventory.application.drawer.runtimeActions.columns.${key}`)

  return [
    {
      title: tKey("tool"),
      render: CellTable,
      ...getDefaultColumnParams("toolName")
    },
    {
      title: tKey("accessType"),
      width: 140,
      render: (key: string) => CellTable(t(key)),
      ...getDefaultColumnParams("accessTypeKey")
    },
    {
      title: tKey("auditEvent"),
      width: 140,
      render: CellTable,
      ...getDefaultColumnParams("auditEvent")
    },
    {
      title: tKey("target"),
      render: CellTable,
      ...getDefaultColumnParams("target")
    },
    {
      title: tKey("decision"),
      width: 110,
      render: StatusTagCell(t),
      ...getDefaultColumnParams("decisionTag")
    },
    {
      title: tKey("ruleVersion"),
      width: 70,
      render: CellTable,
      ...getDefaultColumnParams("ruleVersion")
    },
    {
      title: tKey("count"),
      width: 80,
      render: CellTable,
      ...getDefaultColumnParams("count")
    },
    {
      title: tKey("lastSeen"),
      width: 170,
      render: CellTable,
      ...getDefaultColumnParams("lastSeenUserLocale")
    }
  ]
}
